<template>
    <a href="#" v-on:click="addNote" v-bind:class="[{'fly':animated}, classToSet]" v-on:animationend="animated = false; added = ! added">
        <file-minus-icon v-if="added" class="added"></file-minus-icon>
        <file-plus-icon v-else></file-plus-icon>
    </a>
</template>
<script>
    import { FilePlusIcon, FileMinusIcon } from 'vue-feather-icons'
    import CustomEvents from '@/CustomEvents'

    export default {
        components:{
            FilePlusIcon,
            FileMinusIcon,
            CustomEvents
        },
        name: 'AddNoteLink',
        created: function (){
            this.added = (this.$selectedURLS.indexOf(this.textToAdd) !== -1);
        },
        data: function (){
            return {
                animated: false,
                added: false
            }
        },
        props: {
            textToAdd: String,
            classToSet: String
        },
        methods:{
            addNote: function () {
                this.animated = true;
                if (!this.added){
                    CustomEvents.$emit('add-note', this.textToAdd);
                }else{
                    CustomEvents.$emit('remove-note', this.textToAdd);
                }
            }
        }
    };
</script>
<style>
    .added{
        color: #ff0005;
    }

    a{
        color: blueviolet;
    }

    .fly{
        animation: flyUp 300ms ease 0s 1;
        animation-fill-mode: forwards;
    }

    @keyframes flyUp {
        0% {
            opacity: 1;
            position: relative;
        }

        25% {
            transform: scale(2);
        }

        50%{
            opacity: 1;
        }

        100% {
            color: blueviolet;
            opacity: 0;
            transform: translateY(-100px) translateX(10px) scale(2);
        }
    }
</style>
